<template>
    <div class="Footer">
        <div class="App-space very-very-small"/>
        <div class="Footer__container roboto"> 
            <div class="Footer__compagnie">© Compagnie Blasco</div>
            <div class="row">
               <!--  <div class="App-icon" @click="onClick('google')"><Google/></div>
                <div class="App-icon" @click="onClick('apple')"><Apple/></div>
                <div class="App-icon" @click="onClick('fb')"><Fb/></div> -->

                <div class="Footer__phone">+1 (514) 862-2595</div>
                <div class="App-icon"   
                    v-clipboard:copy="mail"
                    v-clipboard:success="onCopy"><Email/></div>
            </div>
        </div>
        <div class="App-space very-very-small"/>
    </div>
</template>

<script>

import gsap from "gsap"
import Colors from '@/config/Colors'
import ScrollToPlugin from "gsap/ScrollToPlugin"
import Fb from '@/components/assets/svg/Fb'
import Email from '@/components/assets/svg/Email'
import Apple from '@/components/assets/svg/Apple'
import Google from '@/components/assets/svg/Google'
import Settings from '@/config/Settings'

gsap.registerPlugin(ScrollToPlugin)

export default {

    name: 'Footer',
    components: { Fb, Email, Apple, Google },
    data: ()=>({
        mail: ''
    }),
    computed:{
        tint() { return this.$store.getters['commons/tint'] }
    },

    created() {
        this.mail = Settings.email
    },

    mounted() { 
        this.$nextTick(()=>{
            // console.log('Footer');
        })
    },
    methods: {
        onClick(ref) {
            window.open(Settings.link[ref], '_blank')
        },
        onCopy() {
            this.$store.commit('commons/ADD_ALERT', 'clipboard')
        },
        getTint() {
            return this.tint
        },
    }


}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Footer
    width 100%
    position relative
    bottom 0
    left 50%
    transform translateX(-50%)
    background-color rgba(white, 1)
    width 100%
    max-width 880px 

    &__container
        width 100%
        // height calc(var(--hd)/2)
        display flex
        justify-content space-between
        align-items center
        padding 0 calc(var(--mw)/2) 

    &__compagnie    
        font-size .81em 

    &__phone 
        font-size .81em 
        display flex
        align-items center
        padding-right 4px
    
</style>


